import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms'; 
import { ActivatedRoute, Router } from '@angular/router'; 
import { InvoiceService } from '../_services/invoice.service';
import { ClientService } from 'app/_services/client.service';
import { TokenStorageService } from '../_services/token-storage.service';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import flatpickr from "flatpickr";
import * as moment from 'moment'; 


@Component({
  selector: 'app-edit-invoice',
  templateUrl: './edit-invoice.component.html',
  styleUrls: ['./invoices.component.scss']
})
export class EditInvoiceComponent implements OnInit {
  baseUrl = environment.baseUrl;
  contactUUID: string = "";
  invoiceId: number = 0;
  clientId: number = 0;
  clientInfo: any = [];
  submissionId: number = 0;
  submissionInfo: any = [];
  job_i: number = 0;

  contactTypeList: any = [];
  languageList: any = [];
  referralList: any = [];
  invoiceInfo: any = {};
  invoiceJobsList: any = [];
  invoiceJobsForm: FormGroup = new FormGroup({});
  invoicePayments: any = []; //tracking only
  invoicePaymentsList: any = [];
  invoicePaymentsForm: FormGroup = new FormGroup({});
  invoiceSendList: any = [];
  invoiceSendForm: FormGroup = new FormGroup({});
  orderInfoTotals: any = [];
  update_message: string = "";
  update_message_email_sent: string = "";
  payPick: any;
  invoiceHistory: any = [];

  editInvoiceForm: FormGroup = new FormGroup({
     //client related
    first_name: new FormControl(""),
    last_name: new FormControl(""),
    gender: new FormControl(""),
    address: new FormControl(""),
    address2: new FormControl(""),
    city: new FormControl(""),
    province: new FormControl(""),
    country: new FormControl(""),
    postalcode: new FormControl(""),
    language: new FormControl(""),
    referral: new FormControl(""),
    account_fname: new FormControl(""),
    account_lname: new FormControl(""),
    //invoice related
    sent_postal: new FormControl(""),
    sent_postal_date: new FormControl(""),
    sent_email: new FormControl(""),
    sent_email_date: new FormControl(""),

    invoice_created_date: new FormControl(""),
    status: new FormControl(""),
  })

  /* not used
  sendInvoiceForm: FormGroup = new FormGroup({ 
    list_of_emails: new FormControl(""),
  });
  */

  constructor(
    private http: HttpClient,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private tokenStorage: TokenStorageService,
    private invoice: InvoiceService,
    private clients: ClientService,
  ) { }


  ngOnInit(): void {
    this.contactUUID = this.tokenStorage.getToken() || "";
    this.invoiceId = this.activatedRoute.snapshot.params['factureid'];

    this.invoice.getInvoice$(this.contactUUID, this.invoiceId).subscribe({
      next: (data: {}) => {
        this.invoiceInfo = data;
        this.clientInfo = this.invoiceInfo['client'];
        this.submissionInfo = this.invoiceInfo['submission'];
        this.contactTypeList = this.clientInfo.contacts;
        this.invoiceJobsList = this.invoiceInfo['jobs'];
        //this.invoiceJobsList.reverse();
        console.log('pp',this.invoiceInfo['payments'].length);
        this.invoicePaymentsList = this.invoiceInfo['payments'];
        this.invoiceInfo.sent_email_date = moment(this.invoiceInfo.sent_email_date).format('YYYY-MM-DD H:mm');
        if(this.invoiceInfo.sent_postal_date ) 
          this.invoiceInfo.sent_postal_date = moment(this.invoiceInfo.sent_postal_date).format('YYYY-MM-DD');

        this.invoiceInfo.prov_rate = 0.09975;
        this.invoiceInfo.fed_rate = 0.05;

        this.orderInfoTotals['invoiceitems_subtotal_count']  = Number(0);
        this.orderInfoTotals['invoiceitems_tps_total_count'] = Number(0);
        this.orderInfoTotals['invoiceitems_tvq_total_count'] = Number(0);
        this.orderInfoTotals['invoiceitems_total_count'] = Number(0);
        this.orderInfoTotals['invoiceitems_total_paiements'] = Number(0);
        this.orderInfoTotals['invoiceitems_total_restant'] =Number(0);

        console.log('invoice', this.invoiceInfo);
        console.log('jobs', this.invoiceInfo['jobs']);
        //console.log(this.invoiceInfo['jobs']);
        console.log('pay', this.invoicePaymentsList);
        
        
        //   invoicePaymentsForm: FormGroup = new FormGroup({
        //     //client related
        //     invoicepay-date: new FormControl(""),
        //   });*/
    

        this.editInvoiceForm.setValue({
          first_name: this.clientInfo.client_fname,
          last_name: this.clientInfo.client_lname,
          gender: this.clientInfo.client_gender,
          address: this.clientInfo.client_address,
          address2: this.clientInfo.client_address2,
          city: this.clientInfo.client_city,
          province: this.clientInfo.client_province,
          country: this.clientInfo.client_country,
          postalcode: this.clientInfo.client_postalcode,
          language: this.clientInfo.client_language_id,
          account_fname: this.clientInfo.account_fname,
          account_lname: this.clientInfo.account_lname,
          referral: this.invoiceInfo.rcode,
          invoice_created_date: moment(this.invoiceInfo.created).format('YYYY-MM-DD'),
          sent_email: this.invoiceInfo.sent_email,
          sent_postal: this.invoiceInfo.sent_postal,
          sent_email_date: this.invoiceInfo.sent_email_date,
          sent_postal_date: this.invoiceInfo.sent_postal_date,
          status: this.invoiceInfo.active,
        });
/*
        this.invoiceJobsForm.setValue({
          jobs: this.invoiceJobsList,
        });
*/
        /********* Invoice Jobs ***********/
        if(this.invoiceJobsList.length==0) {
            //this.invoiceJobs.push({ amount: 0, is_taxable: true, description: '', tax_federal: 0, tax_provincial: 0 }); 
            this.invoiceJobsList.push({ amount: 0, is_taxable: true, description: '', tax_federal: 0, tax_provincial: 0 });
        }

        for(let i=0; i < this.invoiceJobsList.length; i++) {
            this.invoiceJobsForm.addControl('invoicejob_amount_'+i, new FormControl(""));
            this.invoiceJobsForm.controls['invoicejob_amount_'+i].patchValue(Number(this.invoiceJobsList[i].amount));
            this.invoiceJobsForm.addControl('invoicejob_description_'+i, new FormControl(""));
            this.invoiceJobsForm.controls['invoicejob_description_'+i].patchValue(this.invoiceJobsList[i].description);
            this.invoiceJobsForm.addControl('invoicejob_is_taxable_'+i, new FormControl(""));
            this.invoiceJobsForm.controls['invoicejob_is_taxable_'+i].patchValue(this.invoiceJobsList[i].is_taxable);
            this.invoiceJobsForm.addControl('invoicejob_tax_provincial_'+i, new FormControl(""));
            this.invoiceJobsForm.controls['invoicejob_tax_provincial_'+i].patchValue(Number(this.invoiceJobsList[i].tax_provincial));
            this.invoiceJobsForm.addControl('invoicejob_tax_federal_'+i, new FormControl(""));
            this.invoiceJobsForm.controls['invoicejob_tax_federal_'+i].patchValue(Number(this.invoiceJobsList[i].tax_federal));

            this.orderInfoTotals['invoiceitems_subtotal_count'] = Number(this.orderInfoTotals['invoiceitems_subtotal_count']) + Number(this.invoiceJobsList[i].amount);
            this.orderInfoTotals['invoiceitems_tps_total_count'] = Number(this.orderInfoTotals['invoiceitems_tps_total_count']) + Number(this.invoiceJobsList[i].tax_federal);
            this.orderInfoTotals['invoiceitems_tvq_total_count'] = Number(this.orderInfoTotals['invoiceitems_tvq_total_count']) + Number(this.invoiceJobsList[i].tax_provincial);
        }  
        //invoice jobs total
        this.orderInfoTotals['invoiceitems_total_count'] = Number(this.orderInfoTotals['invoiceitems_subtotal_count'])+Number(this.orderInfoTotals['invoiceitems_tps_total_count'])+Number(this.orderInfoTotals['invoiceitems_tvq_total_count']);

         /********* Invoice Payments ***********/
        if(this.invoicePaymentsList.length==0) {
          //this.invoicePayments.push({ amount: 0, date: moment(moment.now()).format('YYYY-MM-DD'), description: ''}); 
          //this.invoicePaymentsList.push({ amount: 0, date: moment(moment.now()).format('YYYY-MM-DD'), description: '' });
        }else{
          for(let i=0; i < this.invoicePaymentsList.length; i++) {
            this.invoicePayments.push({ amount: this.invoicePaymentsList[i].amount, date: this.invoicePaymentsList[i].updated, description: this.invoicePaymentsList[i].description}); 
          }
        }

        for(let i=0; i < this.invoicePaymentsList.length; i++) {
            this.invoicePaymentsForm.addControl('invoicepay_amount_'+i, new FormControl(""));
            this.invoicePaymentsForm.controls['invoicepay_amount_'+i].patchValue(Number(this.invoicePaymentsList[i].amount));
            this.invoicePaymentsForm.addControl('invoicepay_date_'+i, new FormControl(""));
            this.invoicePaymentsForm.controls['invoicepay_date_'+i].patchValue(moment(this.invoicePaymentsList[i].created).format('YYYY-MM-DD'));
            this.invoicePaymentsForm.addControl('invoicepay_description_'+i, new FormControl(""));
            this.invoicePaymentsForm.controls['invoicepay_description_'+i].patchValue(this.invoicePaymentsList[i].description);
            
            console.log('adding initial payments', this.invoicePayments[i]);
            this.orderInfoTotals['invoiceitems_total_paiements'] = this.orderInfoTotals['invoiceitems_total_paiements'] + Number(this.invoicePaymentsList[i].amount);
        }  
        //invoice payments total
        this.orderInfoTotals['invoiceitems_total_restant'] = this.orderInfoTotals['invoiceitems_total_count'] - this.orderInfoTotals['invoiceitems_total_paiements'];

        //send invoice emails
        console.log('emails', this.contactTypeList);

        for(let i=0; i < this.contactTypeList.length; i++) {  
          if (this.contactTypeList[i].client_contact_type_id == 4){

            this.contactTypeList[i].selected = true;
            this.invoiceSendForm.addControl('contactTypeSendEmail'+i, new FormControl(""));
            this.invoiceSendForm.controls['contactTypeSendEmail'+i].patchValue(true);
/* not used
              this.sendInvoiceForm.setValue({
                list_of_emails: this.contactTypeList[i].value
              });
*/
          }
        }

        this.invoiceEmailHistory(this.invoiceId);

        for (let i = 0; i < this.clientInfo.length; i++) {
         // this.editSubmissionForm.addControl('note_id_'+i, new FormControl(""));
         // this.editSubmissionForm.controls['note_id_'+i].patchValue(this.suiviNotesList[i].note_id);
        }

        setTimeout(() => {
    
          for(let i=0; i < this.invoicePaymentsList.length; i++) {
           // console.log('this.invoicePaymentsList.length', i);
            this.payPick = flatpickr("#invoicepay_date_"+Number(i), {
              enableTime: false,
              defaultDate: moment(this.invoicePaymentsList[i].created).format('YYYY-MM-DD'),
            });
          }
    
        }, 500);
        
      },
      error: (err: any) => {
        console.log("Something went wrong fetching the invoice: ", err)
      }
    });

    flatpickr(".date", {
        altInput: false,
        altFormat: "F j, Y",
        ariaDateFormat: "Y-m-d",
        dateFormat: "Y-m-d"
    });

   
  }

  openCalendar(e: any): void {
    console.log(e)
  }

  getClient(client: number): void {
    this.clients.getClient$(this.contactUUID, client).subscribe({
      next: data => {
        this.clientInfo = data;
      },
      error: err => {
        console.log("Something went wrong fetching the client: ", err)
      }
    });
  }

  /*  Add an extra empty email field */
  addInvoiceJob(): void  {
    this.invoiceJobsList.push({
        amount: '',
        is_taxable: true,
        description: '',
        tax_federal: 0,
        tax_provincial: 0,
    })
    const job_i=this.invoiceJobsList.length-1;
    console.log(job_i);
    this.invoiceJobsForm.addControl("invoicejob_amount_"+job_i, new FormControl(""));
    this.invoiceJobsForm.controls["invoicejob_amount_"+job_i].patchValue(this.invoiceJobsList[job_i].amount);
    this.invoiceJobsForm.addControl("invoicejob_is_taxable_"+job_i, new FormControl(""));
    this.invoiceJobsForm.controls["invoicejob_is_taxable_"+job_i].patchValue(this.invoiceJobsList[job_i].is_taxable);
    this.invoiceJobsForm.addControl("invoicejob_description_"+job_i, new FormControl(""));
    this.invoiceJobsForm.controls["invoicejob_description_"+job_i].patchValue(this.invoiceJobsList[job_i].description);
    this.invoiceJobsForm.addControl("invoicejob_tax_federal_"+job_i, new FormControl(""));
    this.invoiceJobsForm.addControl("invoicejob_tax_provincial_"+job_i, new FormControl(""));
  }

  trackByCreated(index:any, item:any) { 
    //console.log('the item', item, 'the index', index);
    return item.created; 
  }
   /*  Add an extra empty payment field */
  addInvoicePay(): void  {
    //console.log('pb4 list ',this.invoicePaymentsList);
    let pay_i = this.invoicePaymentsList.length;
    //console.log('pay_i b4', pay_i);
    /*
    this.invoicePaymentsList.push({
        amount: '0',
        created: moment.now(),
        payment_no: '-'
    })
    */

    this.invoicePaymentsList[pay_i] = {
      amount: '',
      created: moment.now(),
      payment_no: '-',
      description: ''
    }
    console.log('new list',  this.invoicePaymentsList);

    pay_i = this.invoicePaymentsList.length-1;
   
   // console.log('pay_i',  pay_i );
    
    //pay_i =this.invoicePaymentsList.length;


    //this.invoicePaymentsList.reload();
   // const pay_i=this.invoicePaymentsList.length-1;
    
    console.log('pay count after', this.invoicePaymentsList.length); 

  // setTimeout(() => {
      
    //  console.log(this.invoicePaymentsList[pay_i].created);

    this.invoicePaymentsForm.addControl("invoicepay_amount_"+pay_i, new FormControl(""));
    this.invoicePaymentsForm.controls['invoicepay_amount_'+pay_i].patchValue(this.invoicePaymentsList[pay_i].amount);
    //this.invoicePaymentsForm.controls['invoicepay_amount_'+pay_i].setValue(this.invoicePaymentsList[pay_i].amount);
    
    this.invoicePaymentsForm.addControl("invoicepay_date_"+pay_i, new FormControl(""));
    this.invoicePaymentsForm.controls['invoicepay_date_'+pay_i].patchValue(moment(this.invoicePaymentsList[pay_i].created).format('YYYY-MM-DD'));
    //this.invoicePaymentsForm.controls['invoicepay_date_'+pay_i].setValue(moment(this.invoicePaymentsList[pay_i].created).format('YYYY-MM-DD'));
    
    this.invoicePaymentsForm.addControl("invoicepay_description_"+pay_i, new FormControl(""));
    this.invoicePaymentsForm.controls['invoicepay_description_'+pay_i].patchValue(this.invoicePaymentsList[pay_i].description);
    //this.invoicePaymentsForm.controls['invoicepay_description_'+pay_i].setValue(this.invoicePaymentsList[pay_i].description);

    console.log('pay_i in timeout after', pay_i);

 //}, 500);

  console.log('pay_i between timeout ', pay_i);

   setTimeout(() => {
      this.payPick = flatpickr("#invoicepay_date_"+pay_i, {
        enableTime: false,
        defaultDate: moment().format('YYYY-MM-DD'),
      });
    }, 500);

    console.log('pay count after',pay_i);
  }

  onChangeInvoiceJob( index:number, fieldValue: any):void {
    let old_amount =  Number(this.invoiceJobsList[index].amount);
    let old_tax_federal =   Number(this.invoiceJobsList[index].tax_federal);
    let old_tax_provincial =   Number(this.invoiceJobsList[index].tax_provincial);
    let temp_amount = isNaN(fieldValue.value);
    console.log('temp amount', temp_amount);
    if(isNaN(fieldValue.value)){
      console.log('zeroing');
      this.invoiceJobsList[index].amount = 0;
    }else{
      console.log('zeroing defined');
     this.invoiceJobsList[index].amount =  Number(fieldValue.value);
    }
    this.invoiceJobsList[index].tax_federal =  Number(this.invoiceJobsList[index].amount *this.invoiceInfo.fed_rate);
    this.invoiceJobsList[index].tax_provincial =  Number(this.invoiceJobsList[index].amount *this.invoiceInfo.prov_rate);

    this.orderInfoTotals['invoiceitems_subtotal_count'] = Number(this.orderInfoTotals['invoiceitems_subtotal_count']) -  Number(old_amount) + Number(this.invoiceJobsList[index].amount);
    this.orderInfoTotals['invoiceitems_tps_total_count'] = Number(this.orderInfoTotals['invoiceitems_tps_total_count']) -  Number(old_tax_federal) + Number(this.invoiceJobsList[index].amount *this.invoiceInfo.fed_rate);
    this.orderInfoTotals['invoiceitems_tvq_total_count'] = Number(this.orderInfoTotals['invoiceitems_tvq_total_count']) -  Number(old_tax_provincial)+ Number(this.invoiceJobsList[index].amount *this.invoiceInfo.prov_rate);
    this.orderInfoTotals['invoiceitems_total_count'] = Number(this.orderInfoTotals['invoiceitems_subtotal_count']) + Number(this.orderInfoTotals['invoiceitems_tps_total_count']) + Number(this.orderInfoTotals['invoiceitems_tvq_total_count']);
    this.orderInfoTotals['invoiceitems_total_restant'] = this.orderInfoTotals['invoiceitems_total_count'] - this.orderInfoTotals['invoiceitems_total_paiements'];

    console.log('index',index);
    console.log('subtot', this.orderInfoTotals['invoiceitems_subtotal_count']);
    console.log('tps', this.orderInfoTotals['invoiceitems_tps_total_count']);
    console.log('tvq', this.orderInfoTotals['invoiceitems_tvq_total_count']);
    console.log('total', this.orderInfoTotals['invoiceitems_total_count']);
    console.log('change job from', old_amount);
    console.log('to job new from', fieldValue.value);
  }

  onChangeInvoiceJobTax( index:number, event: any):void {
    this.invoiceJobsList[index].is_taxable = !event.target.checked;
    let old_tax_federal =   Number(this.invoiceJobsList[index].tax_federal);
    let old_tax_provincial =   Number(this.invoiceJobsList[index].tax_provincial);

    console.log(' tax is ',this.invoiceJobsList[index].is_taxable);

    if(event.target.checked == false) {
      this.invoiceJobsList[index].tax_federal = Number(0);
      this.invoiceJobsList[index].tax_provincial= Number(0);
      old_tax_federal = -old_tax_federal 
      old_tax_provincial = -old_tax_provincial; 
    }else{
      this.invoiceJobsList[index].tax_federal =  Number(this.invoiceJobsList[index].amount) * Number(this.invoiceInfo.fed_rate);
      this.invoiceJobsList[index].tax_provincial =  Number(this.invoiceJobsList[index].amount)  * Number(this.invoiceInfo.prov_rate);
    }
    console.log(' =============================== ');
    console.log(' old fed tax ',old_tax_federal );
    console.log(' new fed tax ',this.invoiceJobsList[index].tax_federal );
    console.log(' old prov tax ',old_tax_provincial );
    console.log(' new prov tax ',this.invoiceJobsList[index].tax_provincial );

    
    this.orderInfoTotals['invoiceitems_tps_total_count'] = Number(this.orderInfoTotals['invoiceitems_tps_total_count']) +  Number(this.invoiceJobsList[index].tax_federal) +  Number(old_tax_federal );
    this.orderInfoTotals['invoiceitems_tvq_total_count'] = Number(this.orderInfoTotals['invoiceitems_tvq_total_count']) +  Number(this.invoiceJobsList[index].tax_provincial) + Number(old_tax_provincial ) ;
    this.orderInfoTotals['invoiceitems_total_count'] = Number(this.orderInfoTotals['invoiceitems_subtotal_count']) + Number(this.orderInfoTotals['invoiceitems_tps_total_count']) + Number(this.orderInfoTotals['invoiceitems_tvq_total_count']);
    
    console.log(' tps ',this.orderInfoTotals['invoiceitems_tps_total_count']);
    console.log(' tvq ',this.orderInfoTotals['invoiceitems_tvq_total_count']);
  }

  onChangeInvoicePayAmount( index:number, fieldValue: any):void {
    let old_payment = Number(this.invoicePaymentsList[index].amount);
    //remove decimal comma formatting from number
    //this.invoicePaymentsList[index].amount = fieldValue.value.replace(/[^\d.-]/g, '');
    this.invoicePaymentsList[index].amount = Number(fieldValue.value);

    console.log('amt', this.invoicePaymentsList[index].amount );

    this.orderInfoTotals['invoiceitems_total_paiements'] =  Number(this.orderInfoTotals['invoiceitems_total_paiements']) - Number(old_payment) + Number(this.invoicePaymentsList[index].amount);
    this.orderInfoTotals['invoiceitems_total_restant'] =  Number(this.orderInfoTotals['invoiceitems_total_count']) -  Number(this.orderInfoTotals['invoiceitems_total_paiements']);
    
    console.log('current value: ', Number(fieldValue.value));
    console.log('pay old value: ', old_payment);
    console.log('to pay new', this.invoicePaymentsList[index].amount);
  }

  removeInvoiceJob(uId: number): void  {
    let old_amount = this.invoiceJobsList[uId].amount ;
    let old_tax_federal =  this.invoiceJobsList[uId].tax_federal  ;
    let old_tax_provincial =  this.invoiceJobsList[uId].tax_provincial ;
    console.log('uid',uId);
    console.log('removing job',this.invoiceJobsList[uId]);

    let potato = this.invoiceJobsList.splice(uId, 1);
    this.invoiceJobsForm.removeControl("invoicejob_description_"+uId);
    this.invoiceJobsForm.removeControl("invoicejob_amount_"+uId);
    this.invoiceJobsForm.removeControl("invoicejob_is_taxable_"+uId);
    this.invoiceJobsForm.removeControl("invoicejob_tax_provincial_"+uId);
    this.invoiceJobsForm.removeControl("invoicejob_tax_federal_"+uId);

    //this.invoiceJobsList["invoicejob_amount_"+uId].amount = 0;
    //this.invoiceJobsList["invoicejob_tax_federal_"+uId].tax_federal =0;
    //this.invoiceJobsList["invoicejob_tax_provincial_"+uId].tax_provincial =0;
    
    this.orderInfoTotals['invoiceitems_subtotal_count'] =  Number(this.orderInfoTotals['invoiceitems_subtotal_count']) - old_amount ;
    this.orderInfoTotals['invoiceitems_tps_total_count'] =  Number(this.orderInfoTotals['invoiceitems_tps_total_count']) - old_tax_federal;
    this.orderInfoTotals['invoiceitems_tvq_total_count'] =  Number(this.orderInfoTotals['invoiceitems_tvq_total_count']) - old_tax_provincial;
    this.orderInfoTotals['invoiceitems_total_count'] = Number(this.orderInfoTotals['invoiceitems_total_count']) -old_amount- old_tax_federal- old_tax_provincial;
    this.orderInfoTotals['invoiceitems_total_restant'] =  Number(this.orderInfoTotals['invoiceitems_total_count']) - this.orderInfoTotals['invoiceitems_total_paiements'];

    //console.log(uId);
    //call remove client info here
  }


  findCurrentIndex(ItemsArray :any, uKey: string): number  {

    console.log('ItemsArray', ItemsArray);

    for(let i=0; i < ItemsArray.length; i++) {
      console.log('stack', ItemsArray[i].created);
      //
      if( ItemsArray[i].created == uKey){
        console.log('needle', uKey);
        return i;
      }
    }
    //const rightIndex = ItemsArray.findIndex(x => created === uKey);
    console.log('index not found');

    return -1;
  }

  removeInvoicePay(uIdKey: any): void  {


    console.log('removing :',uIdKey);
    //let realIndex = -1;
    //realIndex = this.findCurrentIndex(this.invoicePaymentsList, uIdKey); 

    let old_amount = this.invoicePaymentsList[uIdKey].amount ;

    //let old_array = this.invoicePaymentsList;

   // console.log('removing :',uId);
    
    
    //console.log('the array :',this.invoicePaymentsList);

    //for(let i=0; i < this.invoicePaymentsList.length; i++) {

      //console.log('splice :',realIndex);
     // if( realIndex !== -1 ){
        //this.invoicePaymentsForm.removeControl("invoicepay_date_"+realIndex);

         let potato = this.invoicePaymentsList.splice(uIdKey, 1);
         this.invoicePaymentsForm.removeControl("invoicepay_date_"+uIdKey);
         this.invoicePaymentsForm.removeControl("invoicepay_description_"+uIdKey);
         this.invoicePaymentsForm.removeControl("invoicepay_amount_"+uIdKey);
         //this.invoicePaymentsList = old_array;
      //}
      
      console.log('new payments :',this.invoicePaymentsList);
    //}  

   

    this.orderInfoTotals['invoiceitems_total_paiements'] = this.orderInfoTotals['invoiceitems_total_paiements'] - old_amount;
    this.orderInfoTotals['invoiceitems_total_restant'] = this.orderInfoTotals['invoiceitems_total_count'] - this.orderInfoTotals['invoiceitems_total_paiements'];

  }

  goToTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  onSubmit(formValues: any, jobsValues: any, paymentsValues: any): void {

    console.log("All values ", formValues);
    console.log("Job values ", jobsValues);
    console.log("Pay values ", paymentsValues);

    this.invoice.getInvoice$(this.contactUUID, this.invoiceId).subscribe((data: {}) => {
      this.invoiceInfo = data;
    })

    //console.log('payments', this.invoicePaymentsList.length);
    //set empty filed payments to 0
   for(let i=0; i < this.invoicePaymentsList.length; i++) {
     console.log('b4 adjust pay', paymentsValues['invoicepay_amount_'+i]  );
     //console.log('payment:', this.invoicePaymentsList[i].amount);
     if(paymentsValues['invoicepay_amount_'+i] == '' || paymentsValues['invoicepay_amount_'+i] === null ){
      paymentsValues['invoicepay_amount_'+i] = 0;
     }
     //console.log('after adj ', paymentsValues['invoicepay_amount_'+i]);
    }

   for(let i=0; i < this.invoiceJobsList.length; i++) {
      console.log('b4 adjust amnt', jobsValues['invoicejob_amount_'+i]  );
      if(jobsValues['invoicejob_amount_'+i] == '' || jobsValues['invoicejob_amount_'+i] === null ){
        jobsValues['invoicejob_amount_'+i] = 0;
      }
      //console.log('after adj ', jobsValues['invoicejob_amount_'+i]);
    }
  
    formValues.sent_postal_date

    let invoiceInfo: any = {
      "invoice_id": this.invoiceId,
      "updated": this.invoiceInfo.updated,
      "created": formValues.invoice_created_date,
      "sent_postal": this.invoiceInfo.sent_postal,
      "sent_postal_date": formValues.sent_postal_date,
      "active": formValues.status,
      "jobs": jobsValues,
      "payments": paymentsValues,
    }

    setTimeout(() => {
      this.payPick = flatpickr("#invoicepay_date_"+Number(paymentsValues.length-1), {
        enableTime: false,
        defaultDate: moment().format('YYYY-MM-DD'),
    });
    }, 500);

    //this.submitJobsInfos(jobsValues);

    //this.submitPaymentInfos(paymentsValues);

    this.invoice.modifyInvoice$(this.contactUUID, this.invoiceId, invoiceInfo).subscribe({
      next: (data:any) => {
        this.update_message = "mise à jour effectuée";
        console.log("Success updating the invoice", invoiceInfo);
        this.invoiceInfo.updated = data.updated;
        this.goToTop();
      },
      error: (err: any) => {
        console.log("Something went wrong updating the invoice: ", err)
        console.log("oops", invoiceInfo);
      }
    })
  }

  sanitizePhone(phoneNumber: string): string {

    let phoneNumberSanitized = phoneNumber.replace(/\D/g, '');
    phoneNumberSanitized = phoneNumberSanitized.substring(0, 10);
    //console.log('phoneNumberSanitized: ', phoneNumberSanitized);
    return phoneNumberSanitized;
  }

  submitPaymentInfos(info: any): void {
    this.invoice.modifyInvoicePayments$(this.contactUUID, this.invoiceId, info).subscribe({
      next: (data:any)  => {
        console.log("Success updating invoice payments: ", data);
        console.log("Success updating the payment", info);
      },
      error:  (err: any)=> {
        console.log("Something went wrong while updating the invoice payments: ", err);
        console.log("ooops", info);
      }
    });
  }

  submitJobsInfos(info: any): void {
    this.invoice.modifyInvoiceJobs$(this.contactUUID, this.invoiceId, info).subscribe({
      next: (data:any)  => {
        console.log("Success updating invoice jobs: ", data)
      },
      error:  (err: any)  => {
        console.log("Something went wrong while updating the invoice jobs: ", err)
      }
    });
  }

  invoiceEmailHistory (invoice: number): void {
    this.invoice.getInvoiceEmailHistory$(this.contactUUID, this.invoiceId).subscribe({
      next: (data:any)  => {
        console.log("Success getting invoice history: ", data);
        this.invoiceHistory = data;
        for(let i=0; i < this.invoiceHistory.length; i++) {  
          this.invoiceHistory[i].sent_email_date = moment(this.invoiceHistory[i].created).format('YYYY-MM-DD H:mm');
        }
      },
      error:  (err: any)=> {
        console.log("Something went wrong while retrieving invoice history: ", err);
      }
    });
  }

  onChangeCheckEmail( index:number, event: any):void {

    
    this.contactTypeList[index].selected = event.target.checked;
    //console.log('checked', this.contactTypeList[index].value + ' '+ this.contactTypeList[index].selected);
        //!event.target.checked;
        
  } 

  invoiceEmail(invoice: number, invoiceNo: any, emailFormValues: any): void {
    let listOfEmails = '';

    for(let i=0; i < this.contactTypeList.length; i++) {  
      if (this.contactTypeList[i].client_contact_type_id == 4 && this.contactTypeList[i].selected == true){
          
        console.log("emailing",this.contactTypeList[i].value);

        //var value = attr.getNamedItem("ng-value");

        //console.log(value.value);
            //  console.log('send email checked:',i + ' ' + this.editInvoiceForm.('contactTypeEmail'+i).);
              listOfEmails += this.contactTypeList[i].value + ',';
      }
    }
    console.log("listOfEmails ", listOfEmails);

    let info = listOfEmails;
    if(listOfEmails != ''){
        if(confirm("Voulez-vous envoyer la facture à "+ listOfEmails)) {
          this.invoice.exportInvoiceEmail$(this.contactUUID, invoice, info).subscribe({
            next: data => {
              console.log("Success emailing the invoice: ", data);
              //this.goToTop();
              this.update_message_email_sent = 'facture envoyée';
              this.invoiceInfo.sent_email_date = moment(data.sent_email_date).format('YYYY-MM-DD H:mm');
              this.router.navigate([this.router.url]);
              this.invoiceEmailHistory(invoice);
            },
            error: err => {
              console.log("Something went wrong while emailing the invoice: ", err.error.errors)
            }
          });
        }
      }else{
        confirm("Aucun courriel selectionné. La facture ne peut être envoyé ")
      }
  }

  invoicePrintHTML(invoice: number): void {
    console.log(invoice);
    this.invoice.exportInvoicePrint$(this.contactUUID, invoice).subscribe({
      next: data => {
        console.log("Success printing the invoice: ", data)

        let printContents, popupWin: any;
        printContents = document.getElementById('print-section')!.innerHTML;
        popupWin = window.open('', '_blank', 'top=0,left=0,height=100%');
        popupWin.document.open();
        popupWin.document.write(data.invoice);
        setTimeout(function() {
         // popupWin.document.close();
          popupWin.window.print();
        }, 250);
      },
      error: err => {
        console.log("Something went wrong while exporting the invoice for print: ", err.error.errors)
      }
    });
  }

  invoicePrint(invoice: number, name: string): void {
     // TO DO Clean up using the service
     this.http.post(this.baseUrl + `/invoices/` + invoice + `/export/pdf?uuid=` + this.contactUUID, invoice, { responseType: 'blob'}).subscribe(res =>{
      let blob = new Blob([res], { type: 'application/pdf' });
      let pdfUrl = window.URL.createObjectURL(blob);

      let popupWin: any;
      popupWin = window.open(pdfUrl, '_blank', 'top=0,left=0,height=100%,width=auto');

      setTimeout(function() {
        popupWin.window.print();
      }, 250);

    });
  }

  invoicePdf(invoice: number, name: string): void {
    // TO DO Clean up using the service
    this.http.post(this.baseUrl + `/invoices/` + invoice + `/export/pdf?uuid=` + this.contactUUID, invoice, { responseType: 'blob'}).subscribe(res =>{
      let blob = new Blob([res], { type: 'application/pdf' });
      let pdfUrl = window.URL.createObjectURL(blob);

      var PDF_link = document.createElement('a');
      PDF_link.href = pdfUrl;

      // TO DOWNLOAD PDF TO YOUR COMPUTER
      PDF_link.download = "montoit-facture-"+name +".pdf";
      PDF_link.click();
    });
  }


}
